export const GETAPIR = 'deve/GETAPIR';
export const GETAPINAVR = 'deve/GETAPINAVR';
export const GETCODES = 'deve/GETCODES';
export const GETAPIC = 'deve/GETAPIC';
export const GETAPIC2 = 'deve/GETAPIC2';
